import { WappRoom } from '@weblite/ts-action/wapp-room'
import { createStorage } from '../lib/storage'

export const [wappRoomsStorage, wappRoomsReducer] = createStorage<WappRoom>(
  'wappRooms',
)
